import React, { useState,useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  CardContent,
  Modal,
  IconButton,
  Typography,
  Tooltip,
  Grid,
  TextField,
  Alert, 
  AlertTitle, 
  AlertProps,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputLabel,
} from "@mui/material";
import TextareaAutosize from '@mui/base/TextareaAutosize';
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import {checkForRole} from "../../utils/GetAuth";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import {
  Lock,
 } 
from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
 import {getAlertMessageData,saveAlertMessageData, deleteAlertMessage} from "../../utils/GetAlertMessagesData"
 import TableAbstraction from "../../componentUtils/TableAbstraction";
 import moment from 'moment';

 function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      marginLeft:"5px",
      marginRight:"2px",
      width:"250px"
    },
    centerDiv: {
      textAlign: "center",
    },
    accordion: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    root: {},
    divWidth: {
      width: "50%",
    },
    card: {
    },
    gridwidth: {
      width: '100%  !important'
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      minWidth: 160,
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);

// interface AlertState {
//   dateFrom: Date,
//   dateTo: Date,
//   message: string
// }

const AlertSuccess = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

interface rowData {
  fromDate: string;
  toDate: string;
  message: string;
  guid:string;
}

export default function AdminAlertMessages() {
  const classes = useStyles();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const enabled = checkForRole(clientId,salesOrg,'cona_internal_dev');
  const [dateFrom, setDateFrom] = React.useState<string>("");
  const [dateTo, setDateTo] = React.useState<string>("");
  const [message, setMessage] = React.useState<string>("");
  const [openSnack, setOpenSnack] = React.useState(false);
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
  const [alertMessagesData, setAlertMessagesData] = useState<any[]>([]);
  const [selRow, setSelRow] = React.useState<rowData|undefined>(undefined);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const [modalStyle] = React.useState(getModalStyle);
  const handleModalClose = () => {
    setOpenEditWindow(false);
    setDateFrom('');
    setDateTo('');
    setMessage('');
  }


  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };
  
  useEffect(() => {
    if (doneLoading) return;
    getMessagesData();
  }, [alertMessagesData,doneLoading,salesOrg,muiTable,confirmDelete]);

  const getMessagesData = () => {
    getAlertMessageData(salesOrg).then((v) => {
      if(v && v.data) 
      setAlertMessagesData(v.data);
      setDoneLoading(true);
    });
  }

  const handleDateFromChange = (event: any) => {
    event.persist();
    setDateFrom(event.target.value);
  }

  const handleDateToChange = (event: any) => {
    event.persist();
    setDateTo(event.target.value);
  }

  function handleInputChange(ce: React.ChangeEvent<HTMLTextAreaElement>){
    setMessage(ce.target.value);
  }

  const handleDelete = () => {
    if(selRow&&selRow.guid){
      deleteAlertMessage(salesOrg,selRow?.guid).then(ret => {
      if(ret && ret.data){
        setAlertMessagesData(ret.data)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });
   }
    setSelRow(undefined);
  }
  

  const modalBody = (
  
    <div style={modalStyle} className={classes.paper} >
    <Typography variant="h5" className={classes.modalTitle}  paragraph>Add Alert Message</Typography>
    <Grid container spacing={2} className={classes.modalGrid}>
      
          <Grid item xs={14} md={14} xl={14}>
            <Card className={classes.modalCard}>
              <CardContent>
              <Grid container rowSpacing={3} className={classes.modalGrid}>
        <Grid item xs={6} md={6} xl={6} >
            <InputLabel >Date From</InputLabel>
            <TextField placeholder='Date From'
                className={classes.modalInput}
                type="datetime-local"  value={dateFrom} onChange={(ce)=>handleDateFromChange(ce)}></TextField>
            </Grid>
            <Grid item xs={6} md={6} xl={6}>
            <InputLabel >Date To</InputLabel>
            <TextField placeholder='Date To'
                className={classes.modalInput}
                type="datetime-local"  value={dateTo} onChange={(ce)=>handleDateToChange(ce)}></TextField>
            </Grid>
            <Grid item xs={12} md={12} xl={12}>
            <InputLabel >Message</InputLabel>
            <TextField
                color={"primary"}
                multiline
                minRows={5}
                fullWidth
                style={{width: "100%"}}
                placeholder="Enter"
                value={message}
                onChange={handleInputChange}
              />
            {/* <TextareaAutosize
            aria-label="empty textarea"
            placeholder="Enter"value={message}
            onChange={handleInputChange}
            minRows={5}
            style={{width: "100%"}}
          /> */}
            </Grid>
            </Grid>
                    {/* <Button
                        color="primary"
                        variant="contained"
                        className={classes.paragraphButton}
                        disabled={(dateFrom && dateTo && message)?false:true}          
                        onClick={(event) => {
                              if(dateFrom && dateTo && message){
                              saveAlertMessageData(salesOrg,new Date(dateFrom),new Date(dateTo),message).then((result) => {
                              if(result){  
                              setOpenSnack(true);
                              setDateFrom('');
                              setDateTo('');
                              setMessage('');
                              setOpenEditWindow(false);
                              setSelRow(undefined);
                              }
                              else {
                               // alert("error");
                              }
                              })
                              
                              }
                          }
                        }
                      >
                         Save
                    </Button> */}
                </CardContent>
            </Card>
            <div style={{ paddingRight: "5px", textAlign:"right"}}>
              <React.Fragment>
                  <Tooltip title={"Save"}>
                      <IconButton disabled={(dateFrom && dateTo && message)?false:true} 
                      onClick={(event) => {
                        if(dateFrom && dateTo && message){
                          saveAlertMessageData(salesOrg,new Date(dateFrom),new Date(dateTo),message).then((result) => {
                          if(result){  
                          setOpenSnack(true);
                          setDateFrom('');
                          setDateTo('');
                          setMessage('');
                          setOpenEditWindow(false);
                          setSelRow(undefined);
                          getMessagesData();
                          }
                          })
                          }
                      }}>
                          <SaveIcon />
                      </IconButton>
                  </Tooltip>
                  <Tooltip title={"Cancel"}>
                      <IconButton onClick={handleModalClose}>
                          <Clear />
                      </IconButton>
                  </Tooltip>
              </React.Fragment>
        </div>
          </Grid>
                
      </Grid>
    
    </div>


  );


  return ( 
    enabled ? (
    <div className={classes.root}>
    <TableAbstraction
        settingsKey="ADM_ALERT_MSG"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <Tooltip title={`Add Alert Message`}>
                  <IconButton  onClick={() => {
                      handleModalClose();
                     setOpenEditWindow(true);
                  }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              );
            },
          }}
          title="Alert Messages"
          columns={[
            {
                label: "From Date",
                name: "startDate",
                options: {
                  searchable: true,
                  filter: true,
                  customBodyRender: (value: any) => {
                    return (
                        <div>
                        {moment(value).format('YYYY-MM-DD hh:mm A')}
                        </div>
                    );
                  },
                }
                
            },
            {
                label: "To Date",
                name: "endDate",
                options: {
                  searchable: true,
                  filter: true,
                  customBodyRender: (value: any) => {
                    return (
                        <div>
                        {moment(value).format('YYYY-MM-DD hh:mm A')}
                        </div>
                    );
                  },
                },
            },
            
            {
                label: "Message",
                name: "message",
                options: {
                  searchable: true,
                  filter: true,
                },
              },
            {
              label: " ",
              name: "remove",
              options: {
                filter: false,
                setCellProps: () => ({ align: 'right' }),
                renderCell: (props) => {
                  const tableMeta = props.row;
                    if(!!useCompact)
                    return (
                        <React.Fragment>
                          <Tooltip title={"Delete"}>
                            <DeleteIcon
                              fontSize="small" 
                              onClick={() => {
                                setSelRow(tableMeta); setConfirmDelete(true);
                              }} 
                            />
                          </Tooltip>
                        </React.Fragment>
                      );
                    else
                      return (
                          <React.Fragment>
                            <Tooltip title={"Delete"}>
                              <IconButton onClick={() => {
                                  setSelRow(tableMeta); 
                                  setConfirmDelete(true);
                              }}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </React.Fragment>
                        );
                }
              },
            },
          ]}
          data={alertMessagesData}
        />
      {/* 
      <Snackbar open={openSnack} anchorOrigin={{ horizontal:'center', vertical:'top' }} autoHideDuration={6000} onClose={handleClose}>
        <AlertSuccess onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          Message has been saved successfully!
        </AlertSuccess>
      </Snackbar>
       */}

      <Modal
        open={openEditWindow}
        onClose={handleModalClose}
      >
        {modalBody}
      </Modal>

      <Dialog
          open={confirmDelete}
          onClose={()=>setConfirmDelete(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to delete the message {message}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{handleDelete(); setConfirmDelete(false);}} color="primary">
              Yes
            </Button>
            <Button onClick={()=>{
                setSelRow(undefined);
                 setConfirmDelete(false);
            }} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
      
    </div>
    ) : (
          <Alert severity="error">
            <AlertTitle><Lock/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin Alert Message</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
  );
}